import React from 'react';
import './Solutions.css';
import { FaFileInvoiceDollar, FaReceipt, FaCreditCard, FaUsers, FaChartBar, FaGlobe } from 'react-icons/fa';

const Solutions = () => {
  const solutions = [
    {
      icon: <FaFileInvoiceDollar />,
      title: 'Invoice Management',
      description: 'Buat, kirim, dan tracking invoice dengan mudah. Template profesional, auto-reminder, dan status real-time.',
      color: '#3b82f6'
    },
    {
      icon: <FaReceipt />,
      title: 'Subscription Billing',
      description: 'Kelola recurring billing otomatis untuk subscription business. Support berbagai model harga dan billing cycle.',
      color: '#06b6d4'
    },
    {
      icon: <FaCreditCard />,
      title: 'Payment Gateway',
      description: 'Integrasi dengan payment gateway populer. Terima pembayaran via transfer bank, kartu kredit, e-wallet.',
      color: '#8b5cf6'
    },
    {
      icon: <FaUsers />,
      title: 'Customer Management',
      description: 'Database customer lengkap dengan riwayat transaksi, invoice history, dan payment behavior analytics.',
      color: '#10b981'
    },
    {
      icon: <FaChartBar />,
      title: 'Reporting & Analytics',
      description: 'Laporan keuangan otomatis, aging report, revenue forecast, dan business intelligence dashboard.',
      color: '#f59e0b'
    },
    {
      icon: <FaGlobe />,
      title: 'Multi-currency Support',
      description: 'Support multiple mata uang dengan auto exchange rate. Perfect untuk bisnis global dan export-import.',
      color: '#ef4444'
    }
  ];

  return (
    <section id="solutions" className="solutions">
      <div className="container">
        <div className="section-header">
          <span className="section-label">FITUR LENGKAP</span>
          <h2 className="section-title">Semua yang Anda Butuhkan dalam Satu Platform</h2>
          <p className="section-description">
            Fitur billing system yang powerful dan mudah digunakan untuk bisnis modern
          </p>
        </div>

        <div className="solutions-grid">
          {solutions.map((solution, index) => (
            <div key={index} className="solution-card">
              <div className="solution-icon" style={{ background: `linear-gradient(135deg, ${solution.color}, ${solution.color}dd)` }}>
                {solution.icon}
              </div>
              <h3>{solution.title}</h3>
              <p>{solution.description}</p>
              <a href="#contact" className="solution-link">Pelajari Lebih Lanjut →</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
